import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Typography, Stack, IconButton, Divider } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import XIcon from '@mui/icons-material/X';

const socialLinks = [
  { icon: InstagramIcon, url: 'https://www.instagram.com/highway.rangers/', label: 'Instagram' },
  { icon: FacebookIcon, url: 'https://www.facebook.com/profile.php?id=61571521665396', label: 'Facebook' },
  { icon: XIcon, url: 'https://x.com/HighwayRangers', label: 'X (Twitter)' },
  { icon: YouTubeIcon, url: 'https://www.youtube.com/@TexasHighwayRangers', label: 'YouTube' },
];

const footerLinks = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'News', path: '/news' },
];

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'primary.main',
        color: '#fff',
        pt: 8,
        pb: 4,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={4}
          justifyContent="space-between"
          alignItems={{ xs: 'center', md: 'flex-start' }}
          textAlign={{ xs: 'center', md: 'left' }}
        >
          {/* Brand */}
          <Box sx={{ maxWidth: 320 }}>
            <Typography
              variant="h6"
              sx={{
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 800,
                mb: 2,
              }}
            >
              TEXAS HIGHWAY RANGERS
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.85, lineHeight: 1.8 }}>
              A nonprofit built on the dedication of volunteers and the generosity of our community. 
              Every mile we cover is powered by donated time, resources, and heart.
            </Typography>
          </Box>

          {/* Quick Links */}
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, fontSize: '1rem' }}>
              Quick Links
            </Typography>
            <Stack spacing={1}>
              {footerLinks.map((link) => (
                <Typography
                  key={link.path}
                  component={Link}
                  to={link.path}
                  variant="body2"
                  sx={{
                    opacity: 0.85,
                    transition: 'opacity 0.2s',
                    '&:hover': { opacity: 1 },
                  }}
                >
                  {link.label}
                </Typography>
              ))}
            </Stack>
          </Box>

          {/* Contact */}
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, fontSize: '1rem' }}>
              Contact Us
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.85 }}>
              howdy@highwayrangers.com
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.85, mt: 1 }}>
              Serving North Texas
            </Typography>
          </Box>

          {/* Social */}
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, fontSize: '1rem' }}>
              Follow Us
            </Typography>
            <Stack direction="row" spacing={1}>
              {socialLinks.map((social) => (
                <IconButton
                  key={social.label}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  sx={{
                    color: '#fff',
                    bgcolor: 'rgba(255,255,255,0.1)',
                    '&:hover': {
                      bgcolor: 'rgba(255,255,255,0.2)',
                    },
                  }}
                >
                  <social.icon />
                </IconButton>
              ))}
            </Stack>
          </Box>
        </Stack>

        <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.2)' }} />

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <Typography variant="body2" sx={{ opacity: 0.7 }}>
            © {new Date().getFullYear()} Texas Highway Rangers. All rights reserved.
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.7 }}>
            Texans Helping Texans, One Mile at a Time.
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}

export default Footer;
